import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'
import { MassPaymentItemI } from '@/modules/massPayment/types/api/MassPaymentInvoiceItemI'
import { useUserStore } from '@/modules/auth/store'

export interface InvoiceItemI {
  name: string
  amount: string
}

export default class MassPaymentInvoiceItem {
  invoicenum: string
  amount: string
  name: string
  subtotal: string
  tax: string
  taxrate: string
  credit: string
  total: string
  invoiceid: number

  constructor(item: MassPaymentItemI) {
    this.invoicenum = item.invoicenum
    this.amount = `${useUserStore().getUser.currency_code}${item.subtotal}`
    this.name = this.getContentDescriptionList(item.items[0].description)
    this.subtotal = item.subtotal
    this.tax = item.tax
    this.taxrate = item.taxrate
    this.credit = item.credit
    this.total = item.total
    this.invoiceid = item.invoiceid

    ObjectCreationValidator.validate(this)
  }

  getContentDescriptionList(description: { [key: string]: string }): string {
    return Object.entries(description)
      .map(item => description[item[0]])
      .join('; ')
  }
}
